import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import Utils from "../../common/athleteCommon/Utils";
import * as api from "../../common/athleteCommon/API";

interface Props {
    history: any;
}

const PhysiologicalHistory: React.FC<Props> = ({ history }) => {

    const physioList = [{ physioId: 1, physioName: "History of chest pain during exertion" }, { physioId: 2, physioName: "History of fainting" }, { physioId: 3, physioName: "History of Asthma" }, { physioId: 4, physioName: "History of Heart murmur" }, { physioId: 5, physioName: "History of Seizures" }, { physioId: 6, physioName: "History of Heat illness" }]

    const [physioHistory, setPhysioHistory] = useState<any[]>([]);
    const [physio, setPhysio] = useState([]);
    const [physioId, setPhysioId] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        setPhysioHistory(history || [])
    }, [history])

    function addRecord() {
        setIsEdit(false);
        setPhysio([]);
        setOpenModal(true);
    }

    function editDetails(details) {
        setIsEdit(true);
        setPhysio(details.physiological)
        setPhysioId(details.physiologicalProfileId);
        setOpenModal(true);
    }

    function handleSubmit() {
        if (isEdit) {
            updatePhysiological();
        } else {
            const formData = new FormData();
            formData.append("physiological", physio)
            const srgryHstry = api.AddPhysiologicalDetails;
            fetch(srgryHstry, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        })
                            .then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                    // navigate(routes.manipurlogin)
                                }
                            });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        })
                    }
                })
        }
    }

    function updatePhysiological() {
        const formData = new FormData();
        formData.append("physiological", physio)
        const srgryHstry = api.EditPhysiologicalDetails + "/" + physioId;
        fetch(srgryHstry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                        .then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                                // navigate(routes.manipurlogin)
                            }
                        });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body" >
                    <div className="row align-items-center" >
                        <div className="d-flex justify-content-end">
                            <Link className="btn" to="#" onClick={addRecord}>
                                <i className="feather-plus" />
                            </Link>
                        </div>
                        {/* {physioHistory.length > 0 && (
                            <div className="table-responsive mt-4">
                                <table className="table table-bordered">
                                    <thead className="table-light">
                                        <tr>
                                            {Object.keys(physioHistory[0]).map((key) => (
                                                <th key={key} className="text-uppercase text-center">
                                                    {key}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {physioHistory.map((row: any, index: number) => (
                                            <tr key={index}>
                                                {Object.values(row).map((value: any, i: number) => (
                                                    <td key={i} className="text-center">
                                                        {value}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )} */}

                        <div className="table-responsive table-datatble">
                            <table className="table datatable">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="text-uppercase text-center">Physiological</th>
                                        <th className="text-uppercase text-center">Name</th>
                                        <th className="text-uppercase text-center">Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(physioHistory) && physioHistory.map((physio, index) => (
                                        <tr key={index}>
                                            <td className="text-center">{index+1}</td>
                                            <td className="text-center">{physio.name}</td>
                                            <td className="text-center">{(physio.status == 1) ? "Active" : "Inactive"}</td>
                                            <td>
                                                <Link to="#" onClick={() => editDetails(physio)}>
                                                    <i className="feather-edit" />Edit
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                size="md"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Physiological Details</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-lg-12">
                            <label className="form-label">Physiological</label>
                            <Select
                                isMulti
                                value={Array.isArray(physioList)
                                    ? physioList
                                        .filter(phy => physio.includes(phy.physioId))
                                        .map(phy => ({
                                            value: phy.physioId,
                                            label: phy.physioName
                                        }))
                                    : []
                                }
                                onChange={(selectedOptions) => {
                                    // const selectedIds = selectedOptions.map(option => option.value);
                                    const selectedIds = Array.isArray(selectedOptions)
                                        ? selectedOptions.map(option => option.value)
                                        : selectedOptions
                                            ? [selectedOptions.value]
                                            : [];
                                    setPhysio(selectedIds);
                                }}
                                options={Array.isArray(physioList)
                                    ? physioList.map(phy => ({
                                        value: phy.physioId,
                                        label: phy.physioName
                                    }))
                                    : []
                                }
                            />
                        </div>
                    </div>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            type="submit"
                            onClick={handleSubmit}
                        >
                            <b><i className="fas fa-save" />Save</b>
                        </Button>
                    </ModalFooter>
                </ModalBody>
            </Modal>
        </>
    );
};

export default PhysiologicalHistory;